import { Container, CRUDTable } from 'components';

import {
  useDeleteRequest,
  useGetCompanies,
  useGetRequest,
  useMemoState,
  usePatchRequest,
  usePostRequest,
  useUserRole,
} from 'hooks';

import { RetailerGroupDto, RetailersGroupRequest } from 'codegen';
import { InitialTableActions } from 'types';

import {
  getFormattedRetailerGroups,
  handlePatchRetailerGroups,
  handlePostRetailerGroups,
  retailerGroupsColumns,
} from '../../lib';

export const RetailerGroupsTab = () => {
  const [retailerGroups, setRetailerGroups] = useMemoState<RetailerGroupDto[]>([]);

  const [{ companies }] = useGetCompanies(true);

  const { loading, refresh } = useGetRequest<{ retailerGroups: RetailerGroupDto[] }>({
    url: '/retailers/groups',
    options: {
      onSuccess: ({ data }) => {
        if (data.retailerGroups) {
          const formattedGroups = data.retailerGroups.map(getFormattedRetailerGroups);

          setRetailerGroups(formattedGroups);
        }
      },
    },
  });

  const [postRetailerGroups, { loading: postLoading }] = usePostRequest<RetailerGroupDto, RetailersGroupRequest>({
    url: '/retailers/groups',
    options: {
      onSuccess: refresh,
    },
  });

  const [patchRetailerGroups, { loading: patchLoading }] = usePatchRequest<RetailerGroupDto, RetailersGroupRequest>({
    options: {
      onSuccess: refresh,
    },
  });

  const [deleteMatchesItem, { loading: deleteLoading }] = useDeleteRequest({
    options: {
      onSuccess: refresh,
    },
  });

  const { isAdmin } = useUserRole();

  return (
    <Container className='h-[85vh]'>
      <CRUDTable
        verticalScroll
        id='retailer-groups-table'
        columns={retailerGroupsColumns(companies)}
        loading={loading || postLoading || patchLoading || deleteLoading}
        addNewBtn={{ visible: isAdmin, text: 'Add Retailers Group' }}
        dataSource={retailerGroups}
        onPostTableData={handlePostRetailerGroups(postRetailerGroups)}
        onPatchTableData={handlePatchRetailerGroups(patchRetailerGroups)}
        onDeleteTableData={(id) => deleteMatchesItem({ callbackURL: `/retailers/groups/${id}` })}
        initialTableActions={isAdmin ? [{ type: InitialTableActions.Edit }, { type: InitialTableActions.Delete }] : undefined}
      />
    </Container>
  );
};
